// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"406":"fdb3b24a","445":"59237142","475":"77ae256a","550":"6b61334c","567":"313664da","870":"d6708ef9"}[chunkId] + ".css";
};